import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export const CancelTicketIcon = (props: SvgIconProps): ReactElement => {
  return (
    <SvgIcon viewBox="0 0 24 25" {...props}>
      <mask
        id="mask0_73_2515"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_73_2515)">
        <path
          d="M8.4 16.8077L12 13.2078L15.6 16.8077L16.3077 16.1L12.7078 12.5L16.3077 8.9L15.6 8.19225L12 11.7923L8.4 8.19225L7.69225 8.9L11.2923 12.5L7.69225 16.1L8.4 16.8077ZM12.0033 21.5C10.7587 21.5 9.58867 21.2638 8.493 20.7915C7.3975 20.3192 6.4445 19.6782 5.634 18.8685C4.8235 18.0588 4.18192 17.1067 3.70925 16.012C3.23642 14.9175 3 13.7479 3 12.5033C3 11.2587 3.23617 10.0887 3.7085 8.993C4.18083 7.8975 4.82183 6.9445 5.6315 6.134C6.44117 5.3235 7.39333 4.68192 8.488 4.20925C9.5825 3.73642 10.7521 3.5 11.9967 3.5C13.2413 3.5 14.4113 3.73617 15.507 4.2085C16.6025 4.68083 17.5555 5.32183 18.366 6.1315C19.1765 6.94117 19.8181 7.89333 20.2908 8.988C20.7636 10.0825 21 11.2521 21 12.4967C21 13.7413 20.7638 14.9113 20.2915 16.007C19.8192 17.1025 19.1782 18.0555 18.3685 18.866C17.5588 19.6765 16.6067 20.3181 15.512 20.7908C14.4175 21.2636 13.2479 21.5 12.0033 21.5ZM12 20.5C14.2333 20.5 16.125 19.725 17.675 18.175C19.225 16.625 20 14.7333 20 12.5C20 10.2667 19.225 8.375 17.675 6.825C16.125 5.275 14.2333 4.5 12 4.5C9.76667 4.5 7.875 5.275 6.325 6.825C4.775 8.375 4 10.2667 4 12.5C4 14.7333 4.775 16.625 6.325 18.175C7.875 19.725 9.76667 20.5 12 20.5Z"
          fill="#23305F"
        />
      </g>
    </SvgIcon>
  );
};

export default CancelTicketIcon;
